<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2022-02-08 09:38:51
 * @LastEditors: shenlin
 * @LastEditTime: 2022-02-08 09:38:51
-->
<template>
  <div id="CockpitLeft">
    <div class="left-top">
      <cockpit-title title="走访趋势"></cockpit-title>
      <div class="echartsBox">
        <visit-trend></visit-trend>
      </div>
    </div>
    <div class="left-bottom">
      <cockpit-title
        title="政策兑现与发布量"
        enTitle="zcdxyfbl"
      ></cockpit-title>
      <div class="echartsBox">
        <policy></policy>
      </div>
    </div>
  </div>
</template>

<script>
import cockpitTitle from '../cockpit-title.vue'
import VisitTrend from '../left/visitTrend.vue'
import Demand from './demand.vue'
import Policy from '../left/policy.vue'
export default {
  // 组件名称
  name: 'CockpitLeft',
  // VisitTrend Policy
  components: { cockpitTitle, VisitTrend, Policy }
}
</script>
<style scoped lang="scss">
#CockpitLeft {
  position: absolute;
  top: 8%;
  left:54%;
  z-index: 8888;
  height: 100%;
  width: 20%;

  > div {
    display: flex;
    box-sizing: border-box;
    flex-direction: column;
    height: calc((100% - 1rem) / 3);
    margin-bottom: 0.1rem;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .left-top {
    width: 100%;
    .echartsBox {
      width: 100%;
      height: calc(100% - 1rem);
    }
  }
  .left-bottom {
    width: 100%;
    margin-top: 6%;
    .echartsBox {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
